import React from 'react'
import Main from '../components/FaqsPage/Main'

const FaqsPage = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default FaqsPage